import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@ppx/ui/tokens.css";
import "./styles.css";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root not found");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
